import {
    TEAM_SUCCESS,
    TEAM_FAIL,
    SET_MESSAGE,
    TEAM_PENDING,
    ADD_TEAM_SUCCESS,
    ADD_TEAM_FAIL,
    ADD_TEAM_PENDING,
    UPDATE_TEAM_SUCCESS,
    UPDATE_TEAM_FAIL,
    UPDATE_TEAM_PENDING,
    DOWNLOAD_TEAM_SUCCESS,
    DOWNLOAD_TEAM_PENDING,
    DOWNLOAD_TEAM_FAIL,
} from "../types";
import { toast} from 'react-toastify'; 
import UserService from "../../services/user.service";


export const getTeams = (pageNumber, pageSize, searchQuery) => async(dispatch) => {
    dispatch({
        type: TEAM_PENDING,
        payload: { teams: "isLoading" },
    });
    return await UserService.getTeams(pageNumber, pageSize, searchQuery).then(
        (data) => {
            
            data.data.status ?
                dispatch({
                    type: TEAM_SUCCESS,
                    payload: { teams : data.data },
                }) :
                dispatch({
                    type: TEAM_FAIL,
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: TEAM_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        return Promise.reject();
    });
};
//add team
export const addTeams = (body) => async(dispatch) => {
    dispatch({
        type: ADD_TEAM_PENDING,
        payload: { addTeams: "isLoading" },
    });
    return await UserService.addTeam(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: ADD_TEAM_SUCCESS,
                    payload: { addTeams : data.data.status },
                }) :
                dispatch({
                    type: ADD_TEAM_FAIL,
                    payload: { addTeams : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: ADD_TEAM_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: ADD_TEAM_FAIL,
        });
      }); ;;
};

//update team
export const updateTeams = (body) => async(dispatch) => {
    dispatch({
        type: UPDATE_TEAM_PENDING,
        payload: { updateTeams: "isLoading" },
    });
    return await UserService.updateTeam(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: UPDATE_TEAM_SUCCESS,
                    payload: { updateTeams : data.data.status },
                }) :
                dispatch({
                    type: UPDATE_TEAM_FAIL,
                    payload: { updateTeams : data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: UPDATE_TEAM_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    }).finally(()=>{
        dispatch({
          type: UPDATE_TEAM_FAIL,
        });
      }); ;;
};

//Download team data
export const downloadTeam = () => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_TEAM_PENDING,
    payload: { downloadTeam: "isLoading" },
  });
  try {
    const response = await UserService.downloadTeam({
      responseType: "blob",
    });
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
      : "Teams.csv";
    const blob = new Blob([response.data], {
      type: "text/csv",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    toast.success("Team file downloaded successfully!", { autoClose: 2000 });
    dispatch({
      type: DOWNLOAD_TEAM_SUCCESS,
      payload: { downloadTeam: true },
    });
  } catch (error) {
    console.error("Error downloading team file:", error);
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error("Failed to download the team file.", { autoClose: 2000 });
    dispatch({
      type: DOWNLOAD_TEAM_FAIL,
      payload: { downloadTeam: false },
    });
  }
};